/*
 * On peut ajouter ici de nouvelles fonctions qui font office de middleware au framework.
 * Plus de documentation sur notre wiki:
 * http://venezia.appli.dgfip/plugins/mediawiki/wiki/frameworkjs/index.php/Arborescence_CLIR#Middlewares
*/

export default {};